import brandShow from './brands/show'
import commonElementsIndex from './common_elements/index'

import companiesIndex from './companies/index'

import elementOrdersIndex from './element_orders/index'
import elementsIndex from './elements/index' // elements amounts
import warehouseRentListOrder from './elements/warehouse_rent_lists/order'

import installersIndex from './installers/index'

import pagesIndex from './pages/index'
import pagesShow from './pages/show'

import locationsIndex from './locations/index'
import locationsShow from './locations/show'
import locationCampaigns from './locations/campaigns'

import projectsIndex from './project_tickets/index'
import projectsShow from './project_tickets/show'

import projectExpensesEdit from './project_expenses/edit'
import projectExpensesIndex from './project_expenses/index'

import reportsShow from './reports/show'
import tagsShow from './tags/show'

import AdditionalReports from './additional_reports'

import Overviews from './overviews'
import Campaigns from './campaigns'
import vmProjectsIndex from './vm/projects/index'
import projectGroupsIndex from './project_groups/index'

import userForm from './users/form'

import orderRequestsShow from './order_requests/show'

import warehousesShow from './warehouses/show'
import warehousesIndex from './warehouses/index'

export default {
  additional: { reports: AdditionalReports },
  brands: {
    show: brandShow,
  },
  campaigns: {
    index: Campaigns.Index,
    new: Campaigns.FormFields,
    edit: Campaigns.FormFields,
    locations: Campaigns.ChangesMonitor,
    elements: Campaigns.ChangesMonitor,
    show: Campaigns.Show,
    summary: Campaigns.Summary
  },
  common: {
    elements: {
      index: commonElementsIndex,
    },
  },
  companies: {
    index: companiesIndex,
  },
  elements: {
    orders: {
      index: elementOrdersIndex,
    },
    index: elementsIndex,
    warehouse: {
      rent: {
        lists: {
          order: warehouseRentListOrder,
          place_order: warehouseRentListOrder,
        },
      },
    },
  },
  installers: {
    index: installersIndex,
  },
  locations: {
    index: locationsIndex,
    show: locationsShow,
    campaigns: locationCampaigns
  },
  overviews: {
    project_groups: Overviews.ProjectGroups,
    multi_step_workflows: Overviews.ProjectGroups,
    vendors: Overviews.Vendors,
    installers: Overviews.Installers
  },
  pages: {
    index: pagesIndex,
    show: pagesShow,
  },
  project: {
    tickets: {
      index: projectsIndex,
      show: projectsShow,
    },
    expenses: {
      edit: projectExpensesEdit,
      index: projectExpensesIndex,
      new: projectExpensesEdit,
      update: projectExpensesEdit
    },
    groups: {
      index: projectGroupsIndex,
      show: Overviews.ProjectGroupShow
    }
  },
  reports: {
    show: reportsShow,
  },
  tags: {
    show: tagsShow,
  },
  users: {
    new: userForm,
    create: userForm
  },
  vendors: {
    show: Overviews.VendorInstallers
  },
  vm: {
    projects: {
      not_assigned: vmProjectsIndex,
      assigned: vmProjectsIndex,
      completed: vmProjectsIndex,
      expired: vmProjectsIndex
    }
  },
  order: {
    requests: {
      email: {
        templates:{
          show: orderRequestsShow
        }
      }
    }
  },
  warehouses: {
    index: warehousesIndex,
    show: warehousesShow
  }
}
